import React from 'react';

import Stroke from 'shared-vectors/icons/Stroke';
import { Icon } from 'shared-vectors';

import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';

import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

export default function IconMenu({
  isOpen,
}) {
  const cls = useStyles();
  const hambCls = makeClassName([
    cls[mainCls],
    isOpen && cls[`${mainCls}--opn`],
  ]);
  return (
    <span className={hambCls}>
      {
        ['t', 'm', 'b'].map(
          (i) => {
            const iconCls = `${cls[`${mainCls}__i`]} ${cls[`${mainCls}__i-${i}`]}`;
            return <Icon key={i} name={Stroke} className={iconCls} />;
          }
        )
      }
    </span>
  );
}